import { useEffect, useState } from "react";

export function useResendCountdown(initialSeconds = 0) {
  const [timeLeft, setTimeLeft] = useState(initialSeconds);

  useEffect(() => {
    if (timeLeft <= 0) return undefined;

    const timerId = window.setTimeout(() => {
      setTimeLeft((current) => Math.max(current - 1, 0));
    }, 1000);

    return () => window.clearTimeout(timerId);
  }, [timeLeft]);

  return {
    isRunning: timeLeft > 0,
    restart: setTimeLeft,
    timeLeft,
  };
}
